import React from "react";
import SearchSvg from "../../assets/img/svgs/SearchSvg";
import { useTranslation } from "react-i18next";
interface ISEARCHBAR {
  onSearchItems: (value: string) => void;
}
const SearchBarMenu: React.FC<ISEARCHBAR> = (props: ISEARCHBAR) => {
  const { t } = useTranslation();
  const { onSearchItems } = props;
  return (
    <div
      style={{ marginTop: "5px", marginBottom: "15px" }}
      className="pickup_search_wrapper"
    >
      <SearchSvg fillColor="orange" />
      <input
        onChange={(e) => onSearchItems(e.target.value)}
        type="text"
        className="pickup_input_style"
        placeholder={t("search_menu_items")}
      />
    </div>
  );
};

export default SearchBarMenu;
